export default function CheckBox(props: any) {

    return (
        <div className="mb-[9px] flex items-center">
            <input
                type="checkbox"
                id={props.id} 
                checked={props.checked}
                onChange={props.onChange}
            />
            <label 
                className="ml-[8px]"
                htmlFor={props.id}>
                {props.text}
                {props.showAsterisk &&
                    <span className="text-[#FF2828]">*</span>
                }
            </label>
        </div>
    );
}
